(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('nue-ugc-product-stories').forEach((component) => {
      const dialog = component.querySelector('[data-ugc-dialog]');
      if (!dialog) return;

      dialog.querySelectorAll('.nue-ugc-modal__nav').forEach((button) => {
        if (button.parentElement !== dialog) dialog.appendChild(button);
      });
    });
  };

  const run = () => requestAnimationFrame(() => enhance(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('nue-ugc-product-stories') || node.querySelector('nue-ugc-product-stories')) {
          enhance(node.matches('nue-ugc-product-stories') ? node.parentElement || node : node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
